// polyfills for IE
import 'core-js/fn/symbol';
import 'core-js/fn/symbol/iterator';

import React from 'react';
import Slider from 'react-slick';

class PhotoswipeGallery extends React.Component {
  constructor(props) {
    super();
    this.state = {
      images: {},  // the complete set of images with lookup key
      variants: {},
      identity: null,
      gallery: [],  // the ordered set of images to be displayed
      loaded: false,
      options: {}, // used by the configurator, but used here to find what type of variant we currently have
    };
    this.slider = null;
    this.goToSlide.bind(this);

    var self = this;
    var initial = null;
    props.app.bind('DATA_LOADED', function(data) {
      self.load(data);
      if (initial) {
        self.setImages(initial);
      }
    });

    props.app.bind('VARIANT_CHANGED', function(identity) {
      if (!self.state.loaded) {
        initial = identity;
      } else {
        self.setImages(identity);
      }
    });

    props.app.bind('OPTIONS_LOADED', function(data) {
      /*
        state.options = {
          options: Array<ConfigOption>,
          variants: Array<{
            id,
            name,
            model,
            type,
            ...
          }>,
          ...
        };
      */
      self.setState({
        options: data,
      });
    });
  }

  // componentWillUpdate is required to ensure the event-driven code outside react shows the div
  // containing this component before the component is rendered. Using componentDidUpdate means
  // the slick initialisation will occur before the div is visible, thus initialising with zero
  // dimension slides.
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.onUpdated && nextState.gallery.length > 0) {
      this.props.onUpdated();
    }
  }

  // once the gallery has loaded and rendered, we call onReady callback to initialise photoswipe.
  componentDidUpdate(prevProps, prevState) {
    if (this.props.onReady && this.state.gallery.length > 0) {
      this.props.onReady();
    }
  }

  // Images is an object with {image_key: image_object} pairs
  load(data) {
    data.loaded = true;
    this.setState(data);
  }

  goToSlide(index) {
    if (this.slider) {
      this.slider.slickGoTo(index);
    }
  }

  setImages(identity) {
    if (identity in this.state.variants) {
      let gallery = [];
      for (let key of this.state.variants[identity].images) {
        if (key in this.state.images) {
          gallery.push(this.state.images[key]);
        }
      }

      this.setState({
        identity: identity,
        gallery: gallery
      });
    } else {
      this.setState({
        identity: null,
        gallery: []
      });
    }
  }

  renderImage(i) {
    return (
      <div key={i.small.url}>
        <a className="image" href={i.large.url} data-width={i.large.width} data-height={i.large.height}>
          <img className="img-responsive" src={i.small.url} data-width={i.small.width} data-height={i.small.height} />
        </a>
      </div>
    );
  }

  render() {
    let settings = {
      dots: false,
      infinite: false,
      lazyLoad: false,  // can't lazy load and simultaneously get photoswipe to load the complete image set
      slidesToShow: 1,
      slidesToScroll: 1
    };

    // null reference error when no children
    // https://github.com/akiran/react-slick/issues/555
    if (this.state.gallery.length > 0) {

      // what image caption do we need?
      let caption = (<div className="slider-caption">Images for illustrative purposes only.</div>);
      if (this.state.options && this.state.options.variants) {
        const v = this.state.options.variants.find(v => v.id === this.state.identity);

        // only show "actual image" caption if:
        // - variant is pre-loved,
        // - with only 1 available (not 2 or more, or infinite in the case of instrument rental)
        if (v && v.type === 'pl' && v.quantity === 1) {
          caption = (<div className="slider-caption">Images are for the actual product you will receive.</div>);
        }
      }

      return (
        <div>
          <Slider {...settings}
            ref={(slider) => { this.slider = slider; }}>
            {this.state.gallery.map(i => this.renderImage(i))}
          </Slider>
          {caption}
        </div>
      );
    } else {
      return null;
    }
  }
}

export {
  PhotoswipeGallery as default
}


// WEBPACK FOOTER //
// ./js/products/photoswipe-gallery.jsx